module.exports = __webpack_public_path__ + "static/img/step.965e508.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/step.png
// module id = t5S9
// module chunks = 1